module.exports = __webpack_public_path__ + "static/media/DevLab.b10804ac.png";